import(/* webpackMode: "eager" */ "/vercel/path0/apps/claim-butter/app/(root)/layout.tsx")